module.exports = "/static/assets/21739a7b303ece303b023791813412cb.svg";